import Outage from './Outage';

export default Outage;
